import { IOrderFilters } from '@/types';
import { OrderItem } from '@/models/order';

export const useOrderStore = defineStore('order', () => {
    const items = ref<OrderItem[]>([]);
    const total = ref<number>(0);
    const loading = ref<boolean>(false);
    const filters = reactive<IOrderFilters>({
        search: null,
        statusId: null,
        date: null,
    });

    //need to run setInterval only in Order page
    setInterval(() => {
        items.value.forEach((order) => order.calcLeftTime());
    }, 1000);

    return {
        items,
        total,
        loading,
        filters,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useOrderStore, import.meta.hot));
}
